import { currentPage, initNewSection } from '../common/layout';
import { goToUrl, banners, hybridLazyLoad } from '../common/utils/fn';
import initLoadMoreBtn from '../common/load-more-btn';
import '../common/msnt/msnt-lightslider.js';
import 'jquery-scrolltie';
import '../common/jquery.sticky';
import '../common/jquery-snap-scroll';
import '../common/hammer';
import 'url-search-params-polyfill';
import device from "current-device";


currentPage.pageInit = ($page, pageData, pageId) => {

    var isStop = false;
    var clientWidth = document.documentElement.clientWidth;
    var $motor_show_slider = [];
    var slideAuto = true;
    var targetElementsTop   = document.querySelectorAll('.filters-extra .filter-list-menu > li');
    for (let targetElementTop of targetElementsTop) {
        targetElementTop.addEventListener('click', function(){
            targetElementTop.classList.toggle('active');
            let targetElements = targetElementTop.querySelectorAll('li.active ul li a');
            for (let targetElement of targetElements) {
                targetElement.addEventListener('click', function(){
                    targetElementTop.classList.remove('active');
                });
            }
        });
    }
    $('.ss-slider').snapScrollControll();
    $('.sidebar').stickySidebar({ containerSelector: '.content-area' });

    // function initSlider(){

    //     $motor_show_slider = $('#motor_show').lightSlider({
    //         addClass: 'topPromoSlider' + (slideAuto ? ' slide-auto' : ''),
    //         item:1,
    //         loop:true,
    //         slideMargin:0,
    //         auto: slideAuto,
    //         pauseOnHover: true,
    //         pause: 5000,
    //         keyPress: true,
    //         onSliderLoad: function ($slider){
    //             if(slideAuto){
    //                 var $active = $slider.parents('.topPromoSlider').find('.lSPager li.active');
    //                 $active.removeClass('active');
    //                 setTimeout(function(){
    //                     $active.addClass('active');
    //                 },10);
    //             }
    //             var scrollTimeout = null;
    //             $(window).on('scroll', function(event){
    //                 clearTimeout(scrollTimeout);
    //                 scrollTimeout = setTimeout(function(){
    //                     if(isStop || $slider.parent().is('.ls-hover')){
    //                         return;
    //                     }
    //                     var slider = $slider.get(0),
    //                         slider_rect = slider.getBoundingClientRect();
    //                     if(slider_rect.bottom < 150){
    //                         $slider.pause();
    //                         isStop = true;
    //                     }
    //                 }, 300);
    //             });
    //             $slider.find('.item .poster').scrollTie({
    //                 property: 'translateY',
    //                 delay: function(el){
    //                     return 350;
    //                 },
    //                 stopAtValue: document.documentElement.clientHeight,
    //                 speed: isTouch ? 0.15 : 0.3
    //             });
    //         },
    //         onBeforeNextSlide: function (el) {isStop = false;},
    //         onBeforePrevSlide: function (el) {isStop = false;}
    //     });
    //     if($motor_show_slider.length){
    //         $motor_show_slider.removeClass('browseBox');
    //         $motor_show_slider.find('.shareBox, .disqus-comment-count').addClass('light');
    //     }
    // }
    // if(clientWidth >= 768){
    //     initSlider();
    // }


    // var $window = $(window);
    // $window.on('resize', function(){
    //     var clientWidth = document.documentElement.clientWidth;
    //     if(clientWidth < 768 && $motor_show_slider.length){
    //         $motor_show_slider.destroy();
    //         if($motor_show_slider.length){
    //             $motor_show_slider.addClass('browseBox');
    //             $motor_show_slider.find('.shareBox, .disqus-comment-count').removeClass('light');
    //         }
    //         $motor_show_slider = [];
    //     }
    //     if(clientWidth >= 768 && $motor_show_slider.length == 0){
    //         initSlider();
    //     }
    // });

    $('#select_by_car').select2({
        minimumResultsForSearch: -1
    }).on('select2:select', function (e) {
        var selected_element = $(e.currentTarget);
        var select_val = selected_element.val();
        var data_url = $('#select_by_car').data('url');
        var href = data_url + select_val;
        goToUrl(href);
    });

    let makesListElements = document.querySelectorAll('.filter-list-menu-makes li ul li span');
    let referenceNode = document.getElementsByClassName('filter-wrapper')[0];
    let sidebarBlock = document.querySelector('.sidebar .autoshow-details');
    let popupWrapper = document.getElementById('popup-wrapper');

    let filterList = document.querySelectorAll('.filter-list li');
    let startURL = window.location.href;

    let filterDefaultValueFirst = document.querySelector('.filter-list-menu-makes li span');
    let filterDefaultValueSecond = document.querySelector('.filter-list-menu-years li span');

    const filterDefaultValueFirstInnerText = filterDefaultValueFirst.textContent;
    const filterDefaultValueSecondInnerText = filterDefaultValueSecond.textContent;
    const makesList = document.querySelector('.filter-list-menu-makes li ul');
    const makesListFirstChild = makesList.firstElementChild;
    const tabsElement = document.querySelectorAll('.filter-list [data-link]');
    const yearFilter = document.querySelector('.filter-list-menu-years');
    const yearFilterList = yearFilter.querySelector('li ul');
    const yearFilterListFirstChild = yearFilterList.firstElementChild;
    const yearFilterListItems = yearFilterList.querySelectorAll('li span');



    function preSelectOptionsFromURL() {
        const urlParams = new URLSearchParams(window.location.search);
    
        const makeValue = urlParams.get('make');
        const yearValue = urlParams.get('y');
    
        if (makeValue) {
            const makeOption = document.querySelector(`.filter-list-menu-makes li ul li span[data-alias="${makeValue}"]`);
            const years = makeOption.dataset.years.split(',');
            if (makeOption) {
                filterDefaultValueFirst.textContent = makeOption.textContent;
            }
        }
    
        if (yearValue) {
            const yearOption = document.querySelector(`.filter-list-menu-years li ul li span[data-alias="${yearValue}"]`);
            if (yearOption) {
                filterDefaultValueSecond.textContent = yearOption.textContent;
            }
        }
    }

    preSelectOptionsFromURL();
    
    function removeQueryParam(parameterName) {
        let queryParams = new URLSearchParams(window.location.search);
    
        if (queryParams.has(parameterName)) {
            queryParams.delete(parameterName);
            let newUrl = `${window.location.origin}${window.location.pathname}?${queryParams.toString()}`;
            window.history.pushState('obj', `Make ${newUrl}`, newUrl);
            filterDefaultValueSecond.textContent = filterDefaultValueSecondInnerText;
        }
    }

    for (let node of filterList) {
        node.addEventListener('click', function(event) {
            let dataValue = node.dataset.link;
            let currentURLPathName = window.location.pathname;
            let urlArray = currentURLPathName.split('/');

            removeQueryParam('y');

            if (urlArray[urlArray.length - 1] == '') {
                if (urlArray[urlArray.length - 2] !== 'news' && urlArray[urlArray.length - 2] !== 'photos' && urlArray[urlArray.length - 2] !== 'videos' ) {
                    if (dataValue !== 'news') {
                        let currentTab = document.getElementsByClassName('current')[0];
                        urlArray[urlArray.length - 1] = dataValue;
                        urlArray.push('');
                        let urlArrayNew = urlArray.join('/');
                        currentTab.classList.remove('current');
                        node.classList.add('current');
                        if (window.location.search != '') {
                            let newUrl = window.location.origin + urlArrayNew + window.location.search;
                            makeRequest(newUrl);
                            window.history.pushState('obj', `Make ${newUrl}`, `${newUrl}`)
                        } else {
                            let newUrl = window.location.origin + urlArrayNew;
                            makeRequest(newUrl);
                            window.history.pushState('obj', `Make ${newUrl}`, `${newUrl}`)
                        }
                    } else {
                        return;
                    }
                }
                else if (urlArray[urlArray.length - 2] !== dataValue) {
                    let currentTab = document.getElementsByClassName('current')[0];
                    urlArray[urlArray.length - 2] = dataValue;
                    let urlArrayNew = urlArray.join('/');
                    currentTab.classList.remove('current');
                    node.classList.add('current');
                    if (window.location.search) {
                        let newUrl = window.location.origin + urlArrayNew + window.location.search;
                        makeRequest(newUrl);
                        window.history.pushState('obj', `Make ${newUrl}`, `${newUrl}`)
                    } else {
                        let newUrl = window.location.origin + urlArrayNew;
                        makeRequest(newUrl);
                        window.history.pushState('obj', `Make ${newUrl}`, `${newUrl}`)
                    }
                }  
                else if (urlArray[urlArray.length - 2] === 'news' && dataValue === 'news') {
                    return;
                }
            } 
        }, false);
    };

    function handleMakesListElementClick(event) {
        const node = event.target;
        const currentURLSearchParameter = window.location.search;
        const href = 'make=' + node.dataset.alias;
        const valueName = node.textContent;
        const className = node.className;

        if (currentURLSearchParameter === '') {
            if (className !== '') {
                filterDefaultValueFirst.textContent = valueName;
                return;
            } else {
                const newHref = '?' + href;
                makeRequest(newHref);
                filterDefaultValueFirst.textContent = valueName;
                filterDefaultValueSecond.textContent = filterDefaultValueSecondInnerText;
                window.history.pushState('obj', `Make ${newHref}`, newHref);
            }
        } else {
            let params = new URLSearchParams(document.location.search.substring(1));
            if (className !== '') {
                params.forEach(function(value, key) {
                    if (key === 'y') {
                        params.delete(key);
                    }
                    if (key === 'p') {
                        params.delete(key);
                    }
                    params.delete(value);
                    params.delete(key);
                });
                makeRequest(`${location.pathname}`);
                filterDefaultValueFirst.textContent = valueName;
                filterDefaultValueSecond.textContent = filterDefaultValueSecondInnerText;
                window.history.replaceState({}, '', `${location.pathname}`);
            } else {
                let year = params.get('y');
                let make = params.get('make');
                let page = params.get('p');
                if (make !== null) {
                    params.set('make', node.dataset.alias);
                    if (year) {
                        params.delete('y');
                    }
                    if(page) {
                        params.delete('p');
                    }
                    makeRequest(`?${params}`);
                    filterDefaultValueFirst.textContent = valueName;
                    filterDefaultValueSecond.textContent = filterDefaultValueSecondInnerText;
                    window.history.replaceState({}, '', `${location.pathname}?${params}`);
                } else {
                    params.append('make', node.dataset.alias);
                    if (year) {
                        params.delete('y');
                    }
                    if (page) {
                        params.delete('p');
                    }
                    makeRequest(`?${params}`);
                    filterDefaultValueFirst.textContent = valueName;
                    filterDefaultValueSecond.textContent = filterDefaultValueSecondInnerText;
                    window.history.replaceState({}, '', `${location.pathname}?${params}`);
                }
            }
        }   
    }

    function handleYearElementClick(event) {
        const node = event.currentTarget;
        const currentURLSearchParameter = window.location.search;
        const href = 'y=' + node.dataset.alias;
        const valueName = node.textContent;
        const className = node.className;

        if (currentURLSearchParameter === '') {
            if (className !== '') {
                return;
            } else {
                const newHref = '?' + href;
                makeRequest(newHref);
                filterDefaultValueSecond.textContent = valueName;
                window.history.pushState('obj', `Make ${newHref}`, newHref);
            }
        } else {
            let params = new URLSearchParams(document.location.search.substring(1));
            if (className !== '') {
                let newParams = new URLSearchParams(params.toString());
                newParams.delete('y');
                if(newParams.has('p')) {
                    newParams.delete('p');
                }
                let newURL = location.pathname;
                if( newParams.has('make')) {
                    newURL = `${location.pathname}?${newParams.toString()}`;
                }
                makeRequest(newURL);
                filterDefaultValueSecond.textContent = valueName;
                window.history.replaceState({}, '', newURL);
              } else {
                let year = params.get('y');
                if (year !== null) {
                    params.set('y', node.dataset.alias);
                    makeRequest(`?${params}`);
                    filterDefaultValueSecond.textContent = valueName;
                    window.history.replaceState({}, '', `${location.pathname}?${params}`);
                } else {
                    params.append('y', node.dataset.alias);
                    makeRequest(`?${params}`);
                    filterDefaultValueSecond.textContent = valueName;
                    window.history.replaceState({}, '', `${location.pathname}?${params}`);
                }
            }
        }
    }

    for (let node of makesListElements) {
        node.addEventListener('click', handleMakesListElementClick, false);
    }

    if(yearFilterListItems.length > 0) {
        for (let node of yearFilterListItems) {
            node.addEventListener('click', handleYearElementClick, false);
        }
    }

    function updateMakesList(newMenu, makesList) {

        makesList.innerHTML = '';
        makesList.appendChild(makesListFirstChild);
        for (let item of newMenu) {
            let newElement = document.createElement('li');
            newElement.innerHTML = `<span data-alias=${item.alias} data-years=${item.years}>${item.title}</span>`;
            newElement.querySelector('span').addEventListener('click', handleMakesListElementClick, false);
            makesList.appendChild(newElement);
        }
    }
        

    function updateYearsList(yearsList, years) {
        yearsList.innerHTML = '';
        yearsList.appendChild(yearFilterListFirstChild);
        const sortedYears = years.sort((a, b) => b - a); 
        for (let year of sortedYears) {
            let newElement = document.createElement('li');
            newElement.innerHTML = `<span data-alias=${year}>${year}</span>`;
            newElement.querySelector('span').addEventListener('click', handleYearElementClick, false);
            yearsList.appendChild(newElement);
        }
    }
    
    function updateTabs(tabsElement, newMenuContent) {
        tabsElement.forEach(tab => {
            const title = tab.getAttribute('data-link');
            if (newMenuContent[title].content === false) {
                tab.classList.add('disabled');
            } else {
                tab.classList.remove('disabled');
            }
        });
    }

    function makeRequest(url) {
        fetch(url,{
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                throw new Error ('smth went wrong');
            }
        })
        .then(data => {
            const newMenu = JSON.parse(data.menu);
            const newMenuContent = JSON.parse(data.menu_content);
            const queryParams = new URLSearchParams(window.location.search);
            const url = window.location.href;
            const urlArray = url.split('/');
            if(newMenu) {
                let queryParamValue = queryParams.get('make');
                updateTabs(tabsElement, newMenuContent);
                updateMakesList(newMenu, makesList);
                
                for (const element of newMenu) {
                    const dataAlias = element.alias;
                    if (dataAlias === queryParamValue && !queryParams.has('y')) {
                        const years = element.years.split(',');
                        updateYearsList(yearFilterList, years);
                    }
                }
                if(!queryParams.has('y')) {
                    for (const [key, value] of Object.entries(newMenuContent)) {
                        if ((urlArray[urlArray.length - 2] === key) || (urlArray[urlArray.length - 2] !== key && key === 'news' )) {
                            const years = value.years || [];
                            if (years.length > 0) {
                                updateYearsList(yearFilterList, years);
                            }
                        }
                    }
                }
            } else if(!queryParams.has('y')) {
                updateTabs(tabsElement, newMenuContent);
                updateMakesList([], makesList);
                for (const [key, value] of Object.entries(newMenuContent)) {
                    if (urlArray[urlArray.length - 2] === key) {
                        const years = value.years || [];
                        if (years.length > 0) {
                            updateYearsList(yearFilterList, years);
                        }
                    }
                }
            }

            let nextElements = document.querySelectorAll('.filter-wrapper ~ *');
            for (let nextElement of nextElements) {
                nextElement.remove();
            }

            referenceNode.insertAdjacentHTML('afterend', data.html);
            if (sidebarBlock) {
                let sidebars = document.getElementsByClassName('sidebar');
                for (let sidebar of sidebars) {
                    sidebar.insertBefore(sidebarBlock, sidebar.firstChild);
                }
            }

            if (popupWrapper) {
                document.getElementById('page_index_autoshows_detail').appendChild(popupWrapper);
            }
              
            hybridLazyLoad();
            banners();
        })
        .catch(function (error) {  
            console.log('Failed', error);
        });
    }

    /*
    * show popup 
    */
    var popup = document.getElementById('popup-wrapper');
    var infoboxButton = document.getElementsByClassName('infobox')[0];

    if(infoboxButton) {
        infoboxButton.addEventListener('click', function() {
            showPopup();
        });    
    }

    function showPopup() {
      popup.style.display = 'block';
      document.body.style.overflow = 'hidden';

      window.onclick = function(event) {
        if (event.target == popup) {
          popup.style.display = 'none';
          document.body.style.overflow = 'auto';
        }
      };
    }

    initLoadMoreBtn();
}

currentPage.pageLoadMore = ($html, $btnBox) => {
    $btnBox.replaceWith($html);
    initNewSection($html)
    hybridLazyLoad();
    //fn.bigImgLazyload();
    banners($html);
    $('.sidebar').stickySidebar({ containerSelector: '.content-area' });
}